<template>
  <span class="rk-table__caret" :style="{ 'margin-left': '3px' }">
    <i :class="[orderStatus === 'asc' ? 'up-active' : 'up']"></i>
    <i :class="[orderStatus === 'desc' ? 'down-active' : 'down']"></i>
  </span>
</template>

<script>
export default {
  props: ['prop', 'currentSort'],
  computed: {
    orderStatus() {
      const { prop: currentProp, order: currentOrder } = this.currentSort
      if (this.prop === currentProp) {
        return currentOrder
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rk-table__caret {
  height: 11px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;

  i {
    display: block;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 5px;
    height: 5px;
  }

  .up {
    background-image: url('~@/assets/images/sort/triangle.svg');
  }

  .up-active {
    background-image: url('~@/assets/images/sort/triangleActiveUp.svg');
  }

  .down {
    background-image: url('~@/assets/images/sort/triangleDown.svg');
  }

  .down-active {
    background-image: url('~@/assets/images/sort/triangleActiveDown.svg');
  }
}
</style>
